import type {
  IResWebhooksError,
  IResWebhooksOK,
  IResWebhooksUnauthorized,
  ReqCreateWebhooks,
  ReqDeleteWebhooks,
} from '@/types/parcel/webhooks/webhooks.interface';
import type { KyInstance } from 'ky';

type Webhooks = () => Promise<IResWebhooksOK | IResWebhooksError | IResWebhooksUnauthorized>;

type CreateWebhooks = ({
  url,
}: ReqCreateWebhooks) => Promise<IResWebhooksOK | IResWebhooksError | IResWebhooksUnauthorized>;

type DeleteWebhooks = ({
  id,
}: ReqDeleteWebhooks) => Promise<IResWebhooksOK | IResWebhooksError | IResWebhooksUnauthorized>;

export interface IReqWebhooks {
  webhooks: Webhooks;
  createWebhook: CreateWebhooks;
  deleteWebhook: DeleteWebhooks;
}

export function reqWebhooks(http: KyInstance): IReqWebhooks {
  const route = 'api/user';

  return {
    webhooks: async () => {
      const response = await http.get(`${route}/webhooks`);
      return response.json();
    },
    createWebhook: async (url) => {
      const response = await http.post(`${route}/webhooks`, { json: url });
      return response.json();
    },
    deleteWebhook: async ({ id }) => {
      const response = await http.delete(`${route}/webhooks/${id}`);
      return response.json();
    },
  };
}
